import API from "./api"

export const getLeaderboard = (contestId) => {
  return API.get(`/points/leaderboard/${contestId}`)
}